import { BreadcrumbComponent } from './breadcrumb.component';
import { BreadcrumbService } from './breadcrumb.service';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({

  imports: [
    CommonModule,
    HttpModule,
    RouterModule,
    TranslateModule,
  ],

  exports: [BreadcrumbComponent],
  declarations: [BreadcrumbComponent],
  providers: [BreadcrumbService]
})
export class BreadcrumbModule { }




// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/breadcrumb/breadcrumb.module.ts